import { Map as MapIcon } from "lucide-react"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"

type AIChatShowMapButtonProps = {
  onClick: (event: React.MouseEvent) => void
}

/** Outline map CTA shared by global Slick AI and the driver-workspace AI column. */
export function AIChatShowMapButton({ onClick }: AIChatShowMapButtonProps) {
  const { t } = useTranslation()
  return (
    <div className="pt-2">
      <Button
        size="sm"
        variant="outline"
        className="h-7 gap-1.5"
        onClick={onClick}
      >
        <MapIcon className="size-3.5" />
        {t("ai.message.showMap")}
      </Button>
    </div>
  )
}
